import { Option } from "@interfaces/option";
import { createFeature, createReducer, on } from "@ngrx/store";
import { IbgeActions } from "../actions/ibge.actions";

export const ibgeFeatureKey = "ibge";

export interface State {
  states: Option[];
  cities: {
    [key: string]: Option[];
  };
}

export const initialState: State = {
  states: [],
  cities: {}
};

export const reducer = createReducer(
  initialState,
  on(
    IbgeActions.loadStates,
    (state, { states }): State => ({
      ...state,
      states
    })
  ),
  on(
    IbgeActions.loadCities,
    (state, { cities, cacheKey }): State => ({
      ...state,
      cities: {
        ...state.cities,
        [cacheKey]: cities
      }
    })
  )
);

export const ibgeFeature = createFeature({
  name: ibgeFeatureKey,
  reducer
});
